import { render } from "./swatchComponent.vue?vue&type=template&id=7864e9d4"
import script from "./swatchComponent.vue?vue&type=script&lang=js"
export * from "./swatchComponent.vue?vue&type=script&lang=js"

import "./swatchComponent.vue?vue&type=style&index=0&id=7864e9d4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__